export function LogoMark({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" data-testid="logo-mark">
      <rect width="64" height="64" rx="14" fill="#0F172A" stroke="rgba(59,130,246,0.35)" />
      <path d="M12 38 L24 38 L30 20 L37 48 L43 30 L52 30" fill="none" stroke="#3B82F6" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="52" cy="30" r="3" fill="#60A5FA" />
    </svg>
  );
}

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark size={compact ? 30 : 36} />
      <span className="font-display leading-none tracking-tight">
        <span className="block text-[15px] font-800 font-extrabold text-slate-50 tracking-[0.14em]">TRENDSIGHT</span>
        <span className="block text-[10px] font-medium text-blue-400 tracking-[0.5em] mt-0.5">MEDIA</span>
      </span>
    </span>
  );
}
